import { render, staticRenderFns } from "./labeldialog.vue?vue&type=template&id=643f0d0c&scoped=true&"
import script from "./labeldialog.vue?vue&type=script&lang=js&"
export * from "./labeldialog.vue?vue&type=script&lang=js&"
import style0 from "./labeldialog.vue?vue&type=style&index=0&id=643f0d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f0d0c",
  null
  
)

export default component.exports